import axios from 'axios';
import { portalRole } from './api';

export async function downloadDocument(action, params, format, signal) {
  try {
    const response = await axios.get(process.env.REACT_APP_SWIL_GATEWAY || '/swil-api/index.php', {
      params: { action, ...params, format }, responseType: 'blob', timeout: 120000,
      withCredentials: true, signal, headers: { 'X-Portal-Role': portalRole },
    });
    if (signal?.aborted) return;
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = response.headers['content-disposition']?.match(/filename="([^"]+)"/)?.[1] || `${params.bill_no}.${format}`;
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    let payload = error.response?.data;
    if (payload instanceof Blob) {
      try { payload = JSON.parse(await payload.text()); } catch { payload = null; }
    }
    throw new Error(payload?.error?.message || 'Unable to download this document. Please try again.');
  }
}
